import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from "react";
import { Checkbox as MantineCheckBox, Space } from '@mantine/core';
import { GenericInput } from "../../components/inputs/GenericInput";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { saveIntegrationSchedule } from "../../services/integrationService";
import { IntegrationActions } from "../../stateManagement/actions/integrationDashboardActions";
import { SummaryAttributesType, IntegrationEntity, IntegrationSchedule } from "../../types/types";
import { isUndefinedorEmpty } from "../transformer/UnregisteredFunctions";
import { popupType } from "../../types/types"

export default function ReviewPage(props: { 
    increment: () => void,
    decrement: () => void, 
    cancel:()=>void,
    summaryAttributesConfig:SummaryAttributesType[] ,
    entitiesList:IntegrationEntity[]
}) {
    const currentSchedule: IntegrationSchedule = useSelector((state: any) => state.integrationRegistry)
    const summaryAttributes = props.summaryAttributesConfig;

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {setOpen(false); setAgreeCheck(false);}
    const dispatch = useDispatch();
    const [validate, setValidate] = useState(false);
    const [agreeCheck, setAgreeCheck] = useState(false);

    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");

    const openPopup = (message: string, type: popupType) => {
        setPopupType(type)
        setGenericMessage(message)
        setOpenGenericModal(true)
    }
    function validateSchedule(currentSchedule:IntegrationSchedule){
        if(isUndefinedorEmpty(currentSchedule.jobName)){
            openPopup(`Please enter a Job name`, "Error")
            return false;
        }
        if(isUndefinedorEmpty(currentSchedule.lob)){
            openPopup(`Please enter an lob`, "Error")
            return false;
        }
        if(isUndefinedorEmpty(currentSchedule.profileName)){
            openPopup(`Please enter a profileName`, "Error")
            return false;
        }
        if(isUndefinedorEmpty(currentSchedule.entityName) || isUndefinedorEmpty(props.entitiesList.find(s=>s.entityName === currentSchedule.entityName))){
            openPopup(`Please enter a valid record Type`, "Error")
            return false;
        }
        return true;
    }

    async function clickHandler(currentSchedule:IntegrationSchedule){
        if(!validateSchedule(currentSchedule)){
            handleClose();
            return; 
        }
        const response = await saveIntegrationSchedule(currentSchedule)
        if(response.status === 200 || response.status === 201){
            setValidate(true);
            openPopup(`Job Saved Successfully!`, "Success")
            handleClose();
        }
        else {
            openPopup(`Job failed to save, please enter valid details and try again.`, "Error")
        }
        handleClose();
    }

    return (
        <>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={() => setOpenGenericModal(c => {
                    if(validate){
                        props.cancel();
                    }
                    return false;
                })}
            />
            <Stack rowGap={4} >
                {
                    summaryAttributes.map((attribute:SummaryAttributesType) => {
                        const val:string = Object.entries(currentSchedule).filter(([key, value]) => key === attribute.name).map(([key, value]) => value)[0];

                        return <GenericInput
                            key={attribute.name}
                            textFieldInputProps={{
                                label: attribute.displayName + (attribute.required ? " *" : ""),
                                value: val || attribute.value || attribute.defaultValue,
                                select: attribute.options ? true : false,
                                // disabled : val!==undefined && val.length === 0 ? false : true,
                                children: attribute.options ? attribute.options.map((option: string) => (<MenuItem key={option} value={option}>{option}</MenuItem>)) : null,
                                placeholder: "Enter " + attribute.displayName,
                                onChange: (e) => { dispatch(IntegrationActions.setGeneric({ key: attribute.name, val: e.target.value })) }
                            }}
                        />
                    })
                }
                <Box width={"100%"} display="flex">
                <Button className="navigation-btn bottom-bar-navigation-btn" onClick={props.decrement} variant="contained">Previous</Button>
                <Button className="navigation-btn bottom-bar-navigation-btn" onClick={handleOpen} variant="contained">Save</Button>
                </Box>
            </Stack>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                fullWidth={false}
                maxWidth="md"
                style={{margin:40}}
            >
                <Box padding={4}>
                <DialogTitle><Typography variant="h3" component='p' gutterBottom paddingBottom={2}>Agree to terms and conditions</Typography></DialogTitle>
                <DialogContent>
                <DialogContentText>
                    <Typography variant="body1" component='span'>
                        We will periodically fetch data from the configured source. The connection informations are encrypted and stored in our secure store.
                    </Typography>
                </DialogContentText>
                <Space h="lg" />
                <MantineCheckBox
                    checked={agreeCheck}
                    onChange={(e) => setAgreeCheck(e.currentTarget.checked)}
                    styles={{ root: { margin:0 } }}
                    size="sm"
                    label="I agree to the terms and conditions."
                />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    <Button variant="outlined" disabled={!agreeCheck} onClick={()=>clickHandler(currentSchedule)}>Save</Button>
                </DialogActions>
                </Box>
            </Dialog>
        </>
    )
}



